
import { Link } from '@mui/material';

import { ROUTES } from '../../store/constants';
import { AuthCard } from '../cards';
import { PasswordRecoveryForm } from '../forms';

/**
 * Renders a password recovery panel.
 *
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The password recovery panel component.
 */
const PasswordRecoveryPanel = () => {
    return (
        <AuthCard
            title="Recuperar senha"
            form={<PasswordRecoveryForm />}
            footer={
                <Link href={ROUTES.LOGIN} variant="body2">
                    Voltar
                </Link>
            }
        />
    );
};

export default PasswordRecoveryPanel